<template>
  <div class="operation-cfm">
    <Modal v-model="show" title="运营学校确认审批操作" :width="800">
      <div class="main">
        <p>
          审批即表示对本次教师考勤的确认单确认无误，请根据实际情况进行审批操作。如设置运营确认，则会：
        </p>
        <h1>
          ①确认后，学校可见该学校确认单，并在该状态下，学校可进行学校确认。
        </h1>
        <h1>
          ②确认后，会通知给该学校确认单的所有教师，发送一条消息推送，提醒教师进行教师考勤确认。
        </h1>
        <h1>
          ③若学校发现确认单有误，可<span class="color-red">撤回确认</span
          >后，重新让<span class="color-red"
            >教师补签、删除签到考勤或取消指定教师的确认单。</span
          >
        </h1>
        <p>是否确认该操作？</p>
      </div>
      <div slot="footer">
        <div class="modal-430-bottom">
          <Button @click="handleCancle">取消</Button>
          <Button type="primary" @click="handleSubmit"
            >确认单无误，提交运营确认</Button
          >
        </div>
      </div>
    </Modal>
    <Modal
      v-model="resultShow"
      title="确认结果"
      :footer-hide="true"
      :width="800"
    >
      <div class="main">
        <p>①校验通过的表示该教师用户在资管有结算账户，支持教师工资结算。</p>
        <p>
          ②校验失败的表示该教师用户在资管未有结算账户，当月薪酬无法通过平台发送到教师账号中，请在
          <span class="color-red">确认前</span>，及时通过教师进行进件注册。
        </p>
        <h1>
          校验成功通过：<span class="color-red">{{ success }}</span>
          校验失败：{{ failure }}
        </h1>
        <div slot="footer">
          <div class="modal-430-bottom">
            <Button type="primary" @click="handleClose">关闭</Button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import financeCenterApi from '@/request/financeCenter/index.js'
export default {
  props: {
    sheetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      resultShow: false,
      success: 0,
      failure: 0
    }
  },
  mounted() {

  },
  methods: {
    handleShow() {
      this.show = true
    },
    handleHide() {
      this.show = false
    },
    handleCancle() {
      this.handleHide()
    },
    handleSubmit() {
      this.operationConfirmed(this.sheetId)
    },
    handleClose() {
      this.resultShow = false
    },
    async operationConfirmed(sheetId) {
      this.$Spin.show();
      let res = await financeCenterApi.operationConfirmedApi({ sheetId })
      this.$Spin.hide();
      if (res.status == 200) {
        this.failure = res.message ? res.message.failure : 0
        this.success = res.message ? res.message.success : 0
        this.handleHide()
        this.resultShow = true
        this.$emit('on-finish')
      }
    }

  }
}
</script>

<style>
</style>